import React, { useState } from 'react';
import useTranslation from '../../../Hooks/useTranslation';
import RemoveConfirmationModal from '../../BaseModule/Components/RemoveConfirmation/RemoveConfirmationModal';
import apiClient from '../../../Services/ApiClient';
import useApiClient from '../../../Hooks/useApiClient';
import ConfirmationModal from '../../BaseModule/Components/Confirmation/ConfirmationModal';

interface Props {
	userId: string;
}

const RemoveAccountInAppRequest: React.FC<Props> = ({ userId }) => {
	const [isRemoveConfirmationOpen, setIsRemoveConfirmationOpen] =
		useState(false);
	const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
	const { displayError } = useApiClient();
	const { t } = useTranslation();

	const handleRequestAccountRemove = async () => {
		try {
			const response = await apiClient.post(
				`/user/${userId}/delete-request`,
				{},
			);
			if (response.status === 200) {
				setIsConfirmationOpen(true);
			}
		} catch (e) {
			displayError(e);
		}
		setIsRemoveConfirmationOpen(false);
	};

	return (
		<>
			<a
				className='dropdown-item collapse-item'
				onClick={() => setIsRemoveConfirmationOpen(true)}
			>
				{t('component.accountRemoveRequest.title')}
			</a>
			{isRemoveConfirmationOpen && (
				<RemoveConfirmationModal
					opened={isRemoveConfirmationOpen}
					onClose={() => setIsRemoveConfirmationOpen(false)}
					onConfirm={handleRequestAccountRemove}
					confirmationText='component.accountRemoveRequest.confirmationText'
					confirmationTitle='component.accountRemoveRequest.confirmationTitle'
				/>
			)}
			{isConfirmationOpen && (
				<ConfirmationModal
					imageSource='/dist/icons/v2/check-green.svg'
					title='component.accountRemoveRequest.confirmationModalTitle'
					text={t('component.accountRemoveRequest.confirmationModalText') ?? ''}
					isOpen={isConfirmationOpen}
					onClose={() => setIsConfirmationOpen(false)}
				/>
			)}
		</>
	);
};

export default RemoveAccountInAppRequest;
